import { render, staticRenderFns } from "./MeasureInfo.vue?vue&type=template&id=5d3f8c8f&scoped=true"
import script from "./MeasureInfo.vue?vue&type=script&lang=js"
export * from "./MeasureInfo.vue?vue&type=script&lang=js"
import style0 from "./MeasureInfo.vue?vue&type=style&index=0&id=5d3f8c8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3f8c8f",
  null
  
)

export default component.exports